import Axios from 'axios';

const API_URL = process.env.API_URL + '/api/v1/';

class BidangUsaha {
  index() {
    return Axios.get(API_URL + 'bidangusaha-list');
  }

  show(bidangusaha) {
    return Axios.get(API_URL + `bidangusaha/${bidangusaha}`);
  }
}

export default new BidangUsaha();



// WEBPACK FOOTER //
// ./src/api/bidangusaha.js